"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartActionTemplateActionArtifactTypeToJSON = exports.SmartActionTemplateActionArtifactTypeFromJSONTyped = exports.SmartActionTemplateActionArtifactTypeFromJSON = exports.SmartActionTemplateActionArtifactType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var SmartActionTemplateActionArtifactType;
(function (SmartActionTemplateActionArtifactType) {
    SmartActionTemplateActionArtifactType["Labels"] = "labels";
    SmartActionTemplateActionArtifactType["Forms"] = "forms";
    SmartActionTemplateActionArtifactType["Files"] = "files";
    SmartActionTemplateActionArtifactType["Folders"] = "folders";
    SmartActionTemplateActionArtifactType["Links"] = "links";
    SmartActionTemplateActionArtifactType["Invoices"] = "invoices";
    SmartActionTemplateActionArtifactType["Packages"] = "packages";
    SmartActionTemplateActionArtifactType["PackageInstances"] = "packageInstances";
    SmartActionTemplateActionArtifactType["Subscriptions"] = "subscriptions";
    SmartActionTemplateActionArtifactType["Accounts"] = "accounts";
    SmartActionTemplateActionArtifactType["Clients"] = "clients";
    SmartActionTemplateActionArtifactType["Appointments"] = "appointments";
    SmartActionTemplateActionArtifactType["StripeSubscriptions"] = "stripe-subscriptions";
    SmartActionTemplateActionArtifactType["StripeProducts"] = "stripe-products";
})(SmartActionTemplateActionArtifactType || (exports.SmartActionTemplateActionArtifactType = SmartActionTemplateActionArtifactType = {}));
function SmartActionTemplateActionArtifactTypeFromJSON(json) {
    return SmartActionTemplateActionArtifactTypeFromJSONTyped(json, false);
}
exports.SmartActionTemplateActionArtifactTypeFromJSON = SmartActionTemplateActionArtifactTypeFromJSON;
function SmartActionTemplateActionArtifactTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SmartActionTemplateActionArtifactTypeFromJSONTyped = SmartActionTemplateActionArtifactTypeFromJSONTyped;
function SmartActionTemplateActionArtifactTypeToJSON(value) {
    return value;
}
exports.SmartActionTemplateActionArtifactTypeToJSON = SmartActionTemplateActionArtifactTypeToJSON;
//# sourceMappingURL=SmartActionTemplateActionArtifactType.js.map